export default __webpack_public_path__ + "static/media/camera-off.8fd212f3.svg";